import { getWsCustomField, getWsCustomFieldDetail } from '@eureka/services/src/apis/workspace-folder.api'
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core/common/ps-http'
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { CompanyItem, CustomFieldItem, TechTopicItem, CreateMonitorRes } from '../../components/monitor-from-workspace/type'
import _ from 'lodash'

export interface MonitorFromWorkspaceApi {
    getWsCustomField: (params?: Record<string, any>) => Promise<CustomFieldItem[]>
    getWsCustomFieldDetail: (fieldId: string, params?: Record<string, any>) => Promise<CustomFieldItem>
    getCompanyForFolder: (params: { workspaceId: string, selectedFolderIds: string[] }) => Promise<CompanyItem[]>
    postCompanyForMatched: (companyNames: string[]) => Promise<CompanyItem[]>
    getTechTopicForFolder: (params: { workspaceId: string, selectedFolderIds: string[] }) => Promise<TechTopicItem[]>
    createMonitor4Workspace: (params: CreateMonitorRes) => Promise<any>
}

export const MonitorFromWorkspaceApi = Symbol('MonitorFromWorkspaceApi')

@injectable()
export class MonitorFromWorkspaceApiImpl extends PsHttpService implements MonitorFromWorkspaceApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        }
    }

    // 获取工作空间自定义字段列表，过滤只保留层级、选项类型
    async getWsCustomField() {
        // 合并个人、公司的自定义字段
        const [companyRes, personRes] = await Promise.all([
            getWsCustomField({ public_field: true }),
            getWsCustomField({ public_field: false })
        ])
        const custom_field = [...personRes.custom_field, ...companyRes.custom_field]
        return _.filter(custom_field, (item: CustomFieldItem) => _.includes(['LAYER', 'OPTION'], item.field_type)) || []
    }

    // 获取工作空间自定义字段详情
    async getWsCustomFieldDetail(fieldId: string) {
        const res = await getWsCustomFieldDetail(fieldId)
        return res
    }

    // 根据folderIds获取推荐top公司列表
    async getCompanyForFolder(params: { workspaceId: string, selectedFolderIds: string[] }) {
        const res = await this.post<PatSnapSuccessResponseData<CompanyItem[]>>({
            url: '/tech-monitor/workspace/top-company',
            data: {
                space_id: params.workspaceId,
                folder_ids: params.selectedFolderIds,
            },
        })
        return res.data
    }

    // 根据用户输入匹配新增公司
    async postCompanyForMatched(companyNames: string[]) {
        const res = await this.post<PatSnapSuccessResponseData<CompanyItem[]>>({
            url: '/tech-monitor/suggest-company',
            data: {
                company_names: companyNames,
            },
        })
        return res.data
    }

    // 获取技术主题列表
    async getTechTopicForFolder(params: { workspaceId: string, selectedFolderIds: string[] }) {
        const res = await this.post<PatSnapSuccessResponseData<TechTopicItem[]>>({
            url: '/tech-monitor/workspace/top-ttc',
            data: {
                space_id: params.workspaceId,
                folder_ids: params.selectedFolderIds,
            },
        })
        return res.data
    }

    // 创建监控
    async createMonitor4Workspace(params: CreateMonitorRes) {
        const res = await this.post<PatSnapSuccessResponseData<string>>({
            url: '/tech-monitor/workspace/create',
            data: params,
        })
        return res.data
    }
}
